:host {
  display: block;
  max-height: 100%;
  overflow: auto;
}
